import { render, staticRenderFns } from "./businessManagement-G.vue?vue&type=template&id=7cddaf45&scoped=true&"
import script from "./businessManagement-G.vue?vue&type=script&lang=js&"
export * from "./businessManagement-G.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cddaf45",
  null
  
)

export default component.exports